<template>
  <base-button
      :icon="icon"
      :title="text"
      :class="{ active: active }"
      :disabled="!enabled()"
      @click="command(commandArguments)"/>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';

export default {
  name: 'toolbar-button',
  components: {
    BaseButton,
  },
  props: [
    'text',
    'icon',
    'command',
    'commandArguments',
    'enabled',
    'active',
  ],
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

button {
  margin: 0 !important;
  border-radius: 0;

  &:not(:disabled) {
    &.active {
      background: $primary;

      &:hover {
      background: $primary-highlight;
      }

      &:focus {
        background: $primary-highlight;
      }
    }
  }
}
</style>
